import React from 'react';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';

function Footer() {
  return (
    <footer className="footer">
      <div className="mx-auto">
        {/* Social icons bar start */}
        <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-white/20 py-4">
          <div className="col-span-1">
          </div>
          <div className="col-span-1">
            <div className="h-full flex sm:justify-end justify-center sm:my-0 my-2 items-center space-x-4">
              <a href="https://youtube.com/" className="footer-link">
                <YouTubeIcon />
              </a>
              <a href="https://www.facebook.com/" className="footer-link">
                <FacebookRoundedIcon />
              </a>
              <a href="https://www.instagram.com/" className="footer-link">
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>
        {/* Social icons bar end */}

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 py-10">
          <div className="col-span-1 text-center sm:text-left">
            <h6 className="uppercase">Evening School</h6>
            <p>
              Evening School is your go-to platform for learning new skills and advancing your
              career. Join us to explore a variety of courses designed to fit your schedule.
            </p>
          </div>
          <div className="col-span-1 text-center sm:text-left">
            <h6 className="uppercase">Useful Links</h6>
            <ul className="footer-links">
              <li>
                <a href="/home" className="text-white/50">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-white/50">
                  About Us
                </a>
              </li>
            </ul>
          </div>
          <div className="col-span-1 text-center sm:text-left">
            <h6 className="uppercase">Contact Details</h6>
            <ul className="">
              <li>EVENING SCHOOL (PVT) LTD</li>
              <li>076-1688169</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
